<dnv-navigation />
<router-outlet />
